module.exports = __webpack_public_path__ + "static/amt-1ef201ba5c84939c85830125a835a715.png";